import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import { Card } from 'reactstrap';
import Spinner from '~/components/spinner/spinner';
import URLParamBanner from '~/components/urlParamBanner/urlParamBanner';
import ErrorBoundaryContent from '~/components/errorBoundary/content';

export const getVesselTypesQuery = gql`
  query vesselTypes($breweryId: Int!) {
    vesselTypes(breweryId: $breweryId) {
      id
      name
      description
      quantity
      volume
    }
  }
`;

const VesselTypesList = ({ brewery, history }) => (
  <Query query={getVesselTypesQuery} variables={{ breweryId: brewery.id }}>
    {props => {
      const { loading, error, data } = props;
      if (loading) {
        return <Spinner className="absolute absolute-center stroke-brand-red" />;
      }

      if (error) {
        return <ErrorBoundaryContent error={error} />;
      }

      return (
        <Fragment>
          <URLParamBanner name="Vessel type" />
          <Card className="content">
            <table className="table mb0">
              <thead>
                <tr>
                  <th className="bt-n bb-n">Name</th>
                  <th className="bt-n bb-n">Description</th>
                  <th className="bt-n bb-n" />
                </tr>
              </thead>
              <tbody>
                {data.vesselTypes.map((vesselType, idx) => (
                  <tr
                    data-qa={`code-${idx}`}
                    className="table-row pointer"
                    key={vesselType.id}
                    onClick={() => {
                      history.push(`/settings/vesseltypes/${vesselType.id}`);
                    }}
                  >
                    <td>
                      <strong>{vesselType.name}</strong>
                    </td>
                    <td className="mw6">{vesselType.description}</td>
                    <td className="mw6">
                      {vesselType.volume}L * {vesselType.quantity}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Card>
        </Fragment>
      );
    }}
  </Query>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(withRouter(VesselTypesList));



// WEBPACK FOOTER //
// ./src/containers/vesselTypeList/vesselTypeList.jsx